import React from "react";
import ErrorHandler from "../../../components/shared/with-error-handler";
import withAULayout from "../../../components/au.desktop/layout";
import loadable from "@loadable/component";
import PageLoader from "../../../components/shared/page-loader";
import StaticPageMeta from "../../../components/shared/meta-tags/static-meta";
import { STATIC_META_CONSTANTS } from "../../../constants/meta-static-page";
const PrivacyInfoAu = loadable(() => import("../../../components/shared/privacy-info-au"), {
    fallback: <PageLoader />
});

const PrivacyPolicy = () => {
    return (
        <React.Fragment>
            <StaticPageMeta type={STATIC_META_CONSTANTS.PRIVACYPOLICY} />
            <ErrorHandler>
                <PrivacyInfoAu />
            </ErrorHandler>
        </React.Fragment>
    );
};

export default withAULayout(PrivacyPolicy, true, true);
